define('MaxaPartPicker.Details.View', [
    'SCView',
    'eureka_maxapartpicker_details.tpl'
], function (
    SCViewModule,
    eureka_maxapartpicker_details_tpl
) {
    'use strict';

    var SCView = SCViewModule.SCView;

    function MaxaPartPickerDetailsView (options) {
        SCView.call(this, options);
        this.model = options.model;
        this.is_logged_in = options.is_logged_in;
        this.template = eureka_maxapartpicker_details_tpl;
        // console.log("this.model", this.model)
        var self = this

        var url = "https://" + SC.ENVIRONMENT.shoppingDomain + "/api/items?id="
            + this.model.get('itemid') +
            '&fields=itemid,itemimages_detail,storedisplayname2,custitem_sca_in_stock,itemoptions_detail,onlinecustomerprice_detail,urlcomponent'
            + '&currency=GBP&timestamp=' + Date.now()


        try {
            jQuery.ajax(url).done(function (result) {
                // console.log("result in details", result);
                for(var i = 0; i < result.items.length; i++) {
                    if(result.items[i].itemimages_detail.urls) {
                        if (result.items[i].itemimages_detail.urls[0]) {
                            self.model.attributes.imageurl = result.items[i].itemimages_detail.urls[0].url;
                        }
                    }
                    self.model.attributes.price = result.items[i].onlinecustomerprice_detail.onlinecustomerprice_formatted;
                    self.model.attributes.url = result.items[i].urlcomponent;
                    self.model.attributes.displayname = result.items[i].storedisplayname2;
                    self.model.attributes.partCode = result.items[i].itemid;
                    self.model.attributes.inStock = result.items[i].custitem_sca_in_stock;
                }

                self.render()
            })
        }catch (e) {
            self.render()
        }


    }


    MaxaPartPickerDetailsView.prototype = Object.create(SCView.prototype);
    MaxaPartPickerDetailsView.prototype.constructor = MaxaPartPickerDetailsView;

    MaxaPartPickerDetailsView.prototype.getContext = function () {
        return {
            model: this.model,
            display: (this.model.attributes.imageurl),
            isEnvironmentBrowser: SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled,
            url: this.model.attributes.url,
            loggedIn: this.is_logged_in
        }
    }

    return MaxaPartPickerDetailsView
})
